import handleClickOptionCard from './handleClickOptionCard'
import clickEventName from 'utils/DOM/clickEventName'
import handleSortCombo from './handleSortCombo'
import compare from 'ENROLL/quotes/components/compare'
import { startTour, closeTour } from '../components/quotes-tour'
import resetFilters from './resetFilters'
import updateOption from './updateOption'
import updateRange from './updateRange'
import getById from 'utils/DOM/getById'
import handleSort from './handleSort'
import toggleMenu from './toggleMenu'
import compareAppClickPlanTracking from './compareAppClickPlanTracking'
import toggleShoppingTip from '../components/shoppingTip/toggleShoppingTip'
import handleCompare from './handleCompare'
import updateFilters from './updateFilters'
import handleCompareRecommend from './handleCompareRecommend'
import handleOpenModalDental from '../../start-application/registryListenersDOM/handleOpenModalDental'
import handleOpenModalLatitude from '../../start-application/registryListenersDOM/handleOpenModalLatitude'
import {
  handleOpenFlexBenefitsModal,
  handleFlexBenefitLevelPreview,
  handleApplyFlexBenefitLevels
} from '../../start-application/registryListenersDOM/handleFlexBenefitCustomize'
import handleToggleVision from './handleToggleVision'
import handleToggleAddonModal from 'sites/pivothealth.com/fixed-benefit-medical/consumer/quotes/registryListenersDOM/handleToggleAddonModal'
import handleSaveQuote from './handleSaveQuote'
import { preventOnCloseEvent } from 'core/services/onClose'
import handleToggleAddon from './handleToggleAddon'
import handleToggleAddonExternal from './handleToggleAddonExternal'

function enableSlider(id) {
  const node = getById(id)
  if (node && node.noUiSlider) {
    node.noUiSlider.on('change', updateRange)
  }
}

function initListeners() {
  $('body')
    .on(clickEventName, '.sp-email-this-quote', handleSaveQuote)
    .on(clickEventName, '.js-track-plan', compareAppClickPlanTracking)
    .on(clickEventName, '.plan__btn', function (e) {
      const planId = e.currentTarget.dataset.id
      window.dataLayerPushEvent(`COVERAGE_QUOTES-${planId}`)
    })
    .on(clickEventName, '.tile__btn', function (e) {
      const planId = e.target.dataset.id
      window.dataLayerPushEvent(`CLICK_RECOMMENDED_QUOTES-${planId}`)
    })
    .on(clickEventName, '.tiles-compare', function () {
      preventOnCloseEvent()
    })
    .on(clickEventName, '.Header__menu-links', function () {
      preventOnCloseEvent()
    })
    .on(clickEventName, '.ProgressBar__link', function () {
      preventOnCloseEvent()
    })
    .on(clickEventName, '.Filters__title', function () {
      preventOnCloseEvent()
    })
    .on(clickEventName, '.Filters__header-show', function () {
      $('.Filters__body').collapse('toggle')
    })
    .on(clickEventName, '.tile-btm__btn', function (e) {
      window.dataLayerPushEvent(`CLICK_BTM_QUOTES-${e.target.dataset.id}`)
    })
    .on(clickEventName, '.js-compare', handleCompare)
    .on('change', '.plan__compare-input', handleCompareRecommend)
    .on(clickEventName, '.js-reset-filters', e => {
      e.preventDefault()
      resetFilters()
    })
    .on('change', '.js-option', updateOption)
    .on('change', '.js-multiselect-option', updateFilters)
    .on(
      'ontouchend' in document.documentElement ? 'touchend' : 'click',
      '.js-menu',
      toggleMenu
    )
    .on(clickEventName, '.js-sort', handleSort)
    .on('change', '#sort-combo', handleSortCombo)
    .on(clickEventName, '.compareBar__close', compare.handleRemoveAll)
    .on(clickEventName, '.compare-boxes__remove', compare.handleCompareClose)
    .on(clickEventName, '.js-compare-link', compare.goToCompare)
    .on(clickEventName, '.js-option-card', handleClickOptionCard)
    .on(clickEventName, '.plans-tabs__check--btm', closeTour)
    .on(clickEventName, '.js-intro-close', e => {
      e.preventDefault()
      closeTour()
    })
    .on(clickEventName, '#intro-start', startTour)
    .on(clickEventName, '.js-shopping-tip-skip', e => {
      e.preventDefault()
      toggleShoppingTip()
    })
    .on(clickEventName, '.js-modal', e => {
      const target = e.target
      const planId = target.getAttribute('data-id')
      if (planId) {
        window.dataLayerPushEvent(`COVERAGE_QUOTES_DENTAL_VISION-${planId}`)
      }
    })
    .on(clickEventName, '.js-modal', handleOpenModalDental)
    .on(clickEventName, '.js-modal-latitude', e => {
      const target = e.target
      const planId = target.getAttribute('data-id')
      if (planId) {
        window.dataLayerPushEvent(`COVERAGE_QUOTES_LATITUDE-${planId}`)
      }
    })
    .on(clickEventName, '.js-modal-latitude', handleOpenModalLatitude)
    .on(clickEventName, '.js-flex-benefit-customize', handleOpenFlexBenefitsModal)
    .on('change', '.js-flex-benefit-level-select', handleFlexBenefitLevelPreview)
    .on(clickEventName, '.js-flex-benefits-modal-apply', handleApplyFlexBenefitLevels)
    .on('change', '.js-vision-input', handleToggleVision)
    .on('change', '.addon__input', handleToggleAddon)
    .on('change', '.addon__input_external', handleToggleAddonExternal)
    .on(clickEventName, '.js-add-on-btn', handleToggleAddonModal)
    .on(clickEventName, '.js-latitude-btn', handleToggleAddonModal)
    .on(clickEventName, '.plan-addons__dental input.addon__input', function (e) {
      const target = e.target
      const isRecommended = target
        ? target.getAttribute('data-is-recommended') === 'true'
        : false
      if (isRecommended) {
        const planId = target.getAttribute('data-ids')
        window.dataLayerPushEvent(`CLICK_RECOMMENDED_QUOTES_DENTAL_VISION-${planId}`)
      }
    })
    .on(clickEventName, '.plan-addons__latitude input.addon__input', function (e) {
      const target = e.target
      const isRecommended = target
        ? target.getAttribute('data-is-recommended') === 'true'
        : false
      if (isRecommended) {
        const planId = target.getAttribute('data-ids')
        window.dataLayerPushEvent(`CLICK_RECOMMENDED_QUOTES_LATITUDE-${planId}`)
      }
    })
    .on(
      clickEventName,
      '.addOn-modal__info a.addOn__link, .dental-brochure',
      function (e) {
        const planId = e.target.getAttribute('data-ids')
        window.dataLayerPushEvent(`VIEW_BROCHURE_DETAILS_DENTAL_VISION-${planId}`)
      }
    )
    .on(clickEventName, '.latitude-brochure', function (e) {
      const planId = e.target.getAttribute('data-ids')
      window.dataLayerPushEvent(`VIEW_BROCHURE_DETAILS_LATITUDE-${planId}`)
    })

  enableSlider('deductible-range')
  enableSlider('coverage-range')

  $('.dropdown-menu').on('click', function (e) {
    e.stopPropagation()
  })
}

export default initListeners
